export default __webpack_public_path__ + "static/media/vol2_3.46bf09f8.png";